<template>
  <div class="option-item--user">
    <thumbnail :src="thumbnail" size="28px" :username="name" />
    <div class="option__user-data">
      <h5 class="option__title">
        <span class="option__title-inline">
          <span class="option__name-text">{{ name }}</span>
          <lead-quality-crown
            v-if="accountId"
            :account-id="accountId"
            :metadata="leadQualityMetadata"
          />
          <lead-quality-button
            v-if="showLeadQualityControls && contactId"
            :account-id="accountId"
            :contact-id="contactId"
            @quality="$emit('lead-quality', $event)"
            @error="$emit('lead-quality-error', $event)"
          />
          <span v-if="identifier" class="user-identifier">
            (ID: {{ identifier }})
          </span>
        </span>
      </h5>
      <p class="option__body">
        <span v-if="email" class="email-icon-wrap">
          <fluent-icon class="merge-contact--icon" icon="mail" size="12" />
          {{ email }}
        </span>
        <span v-if="phoneNumber" class="phone-icon-wrap">
          <fluent-icon class="merge-contact--icon" icon="call" size="12" />
          {{ phoneNumber }}
        </span>
        <span v-if="!phoneNumber && !email">{{ '---' }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import Thumbnail from '../../../components/widgets/Thumbnail';
import { mapGetters } from 'vuex';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import LeadQualityButton from 'dashboard/components/LeadQualityButton.vue';
import LeadQualityCrown from 'dashboard/components/LeadQualityCrown.vue';

export default {
  components: {
    Thumbnail,
    LeadQualityButton,
    LeadQualityCrown,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    thumbnail: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    identifier: {
      type: [String, Number],
      required: true,
    },
    /** When set with accountId, shows lead quality actions + crown (merge / contact modals). */
    accountId: {
      type: [String, Number],
      default: null,
    },
    /** Full contact row (optional); used for stored lead_quality_metadata. */
    contact: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
    }),
    contactId() {
      if (this.contact && this.contact.id != null) return this.contact.id;
      return this.identifier;
    },
    leadQualityMetadata() {
      if (!this.contact) return null;
      return this.contact.lead_quality_metadata || null;
    },
    showLeadQualityControls() {
      if (!this.accountId) return false;
      return this.isFeatureEnabledonAccount(this.accountId, FEATURE_FLAGS.LEAD_QUALITY);
    },
  },
};
</script>

<style lang="scss" scoped>
.option-item--user {
  @apply flex items-center;
}
.user-identifier {
  @apply text-xs ml-0.5 text-slate-700 dark:text-slate-100;
}
.option__user-data {
  @apply flex flex-col flex-grow ml-2 mr-2;
}
.option__body,
.option__title {
  @apply flex items-center justify-start leading-[1.2] text-sm;
}
.option__body .icon {
  @apply relative top-px mr-0.5 rtl:mr-0 rtl:ml-0.5;
}
.option__title {
  @apply text-slate-800 dark:text-slate-100 font-medium mb-0.5;
}
.option__body {
  @apply text-xs text-slate-700 dark:text-slate-100 mt-1;
}

.option__user-data .option__body {
  > .phone-icon-wrap,
  > .email-icon-wrap {
    @apply w-auto flex items-center;
  }
}

.merge-contact--icon {
  @apply -mb-0.5 mr-0.5;
}

.option__title-inline {
  @apply inline-flex items-center flex-wrap gap-0.5 min-w-0;
}
.option__name-text {
  @apply min-w-0;
}
</style>
